// Global appearance settings listener
// This ensures all components can react to appearance changes globally

export const setupGlobalAppearanceListener = () => {
  // Listen for theme changes and apply immediately
  const handleThemeChange = (event: CustomEvent) => {
    const root = document.documentElement;
    const theme = event.detail;
    
    if (theme === "dark") {
      root.classList.add("dark");
    } else if (theme === "light") {
      root.classList.remove("dark");
    } else {
      // System preference
      if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
        root.classList.add("dark");
      } else {
        root.classList.remove("dark");
      }
    }
  };

  // Listen for timezone changes and update localStorage
  const handleTimezoneChange = (event: CustomEvent) => {
    localStorage.setItem('user_timezone', event.detail);
  };

  // Listen for date format changes and update localStorage
  const handleDateFormatChange = (event: CustomEvent) => {
    localStorage.setItem('user_date_format', event.detail);
  };

  // Listen for time format changes and update localStorage
  const handleTimeFormatChange = (event: CustomEvent) => {
    localStorage.setItem('user_time_format', event.detail);
  };

  // Add event listeners
  window.addEventListener('themeChanged', handleThemeChange as EventListener);
  window.addEventListener('timezoneChanged', handleTimezoneChange as EventListener);
  window.addEventListener('dateFormatChanged', handleDateFormatChange as EventListener);
  window.addEventListener('timeFormatChanged', handleTimeFormatChange as EventListener);

  // Return cleanup function
  return () => {
    window.removeEventListener('themeChanged', handleThemeChange as EventListener);
    window.removeEventListener('timezoneChanged', handleTimezoneChange as EventListener);
    window.removeEventListener('dateFormatChanged', handleDateFormatChange as EventListener);
    window.removeEventListener('timeFormatChanged', handleTimeFormatChange as EventListener);
  };
};

// Initialize global listener
setupGlobalAppearanceListener();
